/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

export default class Bar extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.fillData.fill !== nextProps.fillData.fill) {
      return true;
    }

    if (this.props.max !== nextProps.max) {
      return true;
    }

    if (this.props.products !== nextProps.products) {
      return true;
    }

    return false;
  }

  static getHeight(products, max) {
    return {
      height: `${100 * (products / max)}%`,
    };
  }

  onChange() {
    this.props.onChange({
      from: this.props.from,
      to: this.props.to,
    });
  }

  render() {
    const { products, max, fillData } = this.props;

    const fillPercentage = fillData.fill;
    const style = Bar.getHeight(products, max);

    const opacityStyle = {
      opacity: 1 - fillPercentage,
    };
    return (
      <S.Bar onClick={this.onChange}>
        <S.Filler style={style} data-opacity={fillPercentage} empty={!products}>
          <S.Bar inactive style={opacityStyle} />
        </S.Filler>
      </S.Bar>
    );
  }
}

Bar.propTypes = {
  id: PropTypes.number.isRequired,
  fillData: PropTypes.shape({
    fill: PropTypes.number,
    from: PropTypes.bool,
    to: PropTypes.bool,
  }).isRequired,
  products: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  to: PropTypes.number.isRequired,
  from: PropTypes.number.isRequired,
};
